module.exports = __webpack_public_path__ + "static/media/tipps_cta_icon.bf8cd544.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tipps_cta_icon.svg
// module id = 136
// module chunks = 0